import { PostAPI } from 'Components/Helper/Helpers';

export const BeneAdd = async (request) => {
    return PostAPI(request, 'OnlyApiPayout/AddBenificiary');
};
export const SelectBeneficiary = async (request) => {
    return PostAPI(request, 'OnlyApiPayout/SelectBeneficiary');
};

export const DeleteBene = async (request) => {
    return PostAPI(request, 'OnlyApiPayout/Delete');
};
